import kr from '../../kr/kr';
import DivStatuses from '../../kr/utils/DivStatuses';
import HTMLClass from '../../kr/utils/HTMLClass';

export default class CreateShopForm extends kr.Component {
    init() {
        this.$ = window.jQuery;
        this.captchaInited = false;
        
        this._calling = false;
        this.$form = this.$element.querySelector('form[data-step="confirm_domain"]');
        this.$messages = new DivStatuses(this.$form);
        this._initRecaptcha();
        //this._disableSubmit();
        this.bind();
    }

    bind() {
        this.$form.onsubmit = () => {
            this._handleSubmit();
            return false;
        };

        this.on('change', 'input[name="shop_name"]', (target, event) => {
            if (target.value.length < 4) {
                this._disableSubmit();
                this.$messages.hideMessages();
                this.$messages.message('Minimalna liczba znaków w nazwie to: 4 znaki.', 'error');
            } else {
                this.$messages.hideMessages();
                this._enableSubmit();
            }
        });
    }

    async _handleSubmit()
    {
        if (this._calling) {
            return false;
        }
        this.$messages.hideMessages();
        if (!this.captchaInited) {
            this.$messages.message('Czekam na załadowanie zależności... Spróbuj za chwilę.', 'error');
            return false;
        }

        const formDataCheck = new FormData(this.$form);
        const shopName = formDataCheck.get('shop_name');
        const categoryId = formDataCheck.get('category_id') == null ? 0 : parseInt(formDataCheck.get('category_id'));
        if (!/^[\w-_]{4,}$/.test(shopName)) {
            this.$messages.message('Błąd walidacji. Nazwa sklepu może składać się ze znaków: a-z', 'error');
            this._disableSubmit();
            return false;
        }

        this._calling = true;
        this._disableSubmit();
        this.$messages.showLoader(window.selly_create_shop.loading_message);
        const token = await this._generateRecaptcha();
        try {
            const check = await this._isNameValid(formDataCheck);
            if (check.success === false) {
                throw check.error;
            }
        } catch (error) {
            this.$messages.hideLoader();
            this._disableSubmit();
            this.$messages.message(error, 'error');
            this._calling = false;
            return false;
        }
        const formData = new FormData(this.$form);
        formData.append('action', 'sellyconfirmshop');
        await this._generateRecaptcha();
        this.$.ajax({
            type: 'POST',
            url: window.selly_create_shop.ajaxurl,
            data: formData,
            cache: false,
            processData: false, 
            contentType: false, 
            success: this._successForm.bind(this),
            fail: () => {
                this._calling = false;
                this._enableSubmit(this.$form);
                this.$messages.hideLoader();
                this.$messages.message('Wystąpił nieokreślony błąd.', 'error');
            }
        })
    }

    _successForm(response) 
    {
        this._calling = false;
        this.$messages.hideLoader();
        if (!response.success) {
            this.$messages.message(response.error, 'error');
            this._enableSubmit(this.$form);
            return;
        }

        this.$element.parentNode.removeChild(this.$element);

        const div = document.createElement('div');
        div.innerHTML = response.tpl;
        document.querySelector('.js-sellyCS').append(div);
    }


    async _isNameValid(formData)
    {
        formData.append('action', 'sellycheckavailshop');
        return this.$.ajax({
            type: 'POST',
            url: window.selly_create_shop.ajaxurl,
            data: formData,
            cache: false,
            processData: false, 
            contentType: false,
        })
    }

    _generateRecaptcha() 
    {
        const input = this.$form.querySelector('.js-sellyCSFormHiddenSpan input[name="token"]');

        return new Promise((res, rej) => {
            grecaptcha.ready(() => {
                grecaptcha.execute(window.selly_create_shop.public_captcha, {action: 'selly'})
                    .then(token => {
                        if (input) {
                            input.value = token;
                        } else {
                            const span = document.createElement('span');
                            HTMLClass.addClass(span, 'js-sellyCSFormHiddenSpan');
                            span.innerHTML = `
                                <input type="hidden" name="token" value="${token}">
                            `;
                            this.$form.append(span);
                        }

                        return res(token);
                    });
            });
        });
    }

    _initRecaptcha()
    {
        this.app.addJs(`https://www.google.com/recaptcha/api.js?render=${window.selly_create_shop.public_captcha}`, true, this._recaptchaCallback.bind(this));
    }

    _recaptchaCallback()
    {
        this.captchaInited = true;
        this._generateRecaptcha();
    }

    _disableSubmit()
    {
        this.$form.querySelector('input[type="submit"]').disabled = "disabled";
    }

    _enableSubmit()
    {
        this.$form.querySelector('input[type="submit"]').disabled = null;
    }
}

kr.registerComponent('.js-sellyCSFormStep2', {
    component: CreateShopForm,
    name: 'CreateShopForm'
});